// extracted by mini-css-extract-plugin
export var section = "styles-module--section--3lT3m";
export var contentContainer = "styles-module--contentContainer--1aJv2";
export var title = "styles-module--title--XJjfD";
export var subtitle = "styles-module--subtitle--2ZFvv";
export var form = "styles-module--form--3z4MB";
export var image = "styles-module--image--1_Vpj";
export var notYetVisible = "styles-module--notYetVisible--3yNXL";
export var visible = "styles-module--visible--2RsLl";